import PropTypes from 'prop-types';
import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import LinkToModuleResource from '../../../../common/resource/LinkToModuleResource';
import { PARCEL_PRICE_STATUS } from '../../../../../config/constants';
import {
  DATE_FORMAT,
  FULL_DATE_TIME_FORMAT,
} from '../../../../../config/locale';
import { tzNormalizeDate } from '../../../../../utils/date';
import EnumStatus from '../../../../common/EnumStatus';

const PricingProfileDateScheduleBasicInformationResource = ({
  id,
  createDate,
  file,
  status,
  user,
  description,
  startDate,
  endDate,
  corporate,
}) => (
  <>
    <ResourceProperty label="ID:">{id}</ResourceProperty>

    <ResourceProperty label="Archivo:">
      <LinkToModuleResource
        href={file}
        text={file}
        colorIcon="text-primary"
        isExternalPath
      />
    </ResourceProperty>

    <ResourceProperty label="Corporativo:">
      {corporate ? 'Sí' : 'No'}
    </ResourceProperty>

    <ResourceProperty label="Fecha Inicio:">
      {tzNormalizeDate({ date: startDate, format: DATE_FORMAT })}
    </ResourceProperty>

    <ResourceProperty label="Fecha Fin:">
      {tzNormalizeDate({ date: endDate, format: DATE_FORMAT })}
    </ResourceProperty>

    <ResourceProperty label="Estado:">
      <EnumStatus enumObject={PARCEL_PRICE_STATUS} enumValue={status} />
    </ResourceProperty>

    <ResourceProperty label="Descripción:">
      {description || '-'}
    </ResourceProperty>

    <ResourceProperty label="Creado por:">
      {user.customer.fullName || '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha de Creación:">
      {tzNormalizeDate({
        date: createDate,
        format: FULL_DATE_TIME_FORMAT,
      })}
    </ResourceProperty>
  </>
);

PricingProfileDateScheduleBasicInformationResource.propTypes = {
  id: PropTypes.number.isRequired,
  createDate: PropTypes.number.isRequired,
  file: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  user: PropTypes.shape({
    customer: PropTypes.shape({
      fullName: PropTypes.shape,
    }),
  }),
  description: PropTypes.string,
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  corporate: PropTypes.bool.isRequired,
};

PricingProfileDateScheduleBasicInformationResource.defaultProps = {
  description: '',
  user: null,
};

export default PricingProfileDateScheduleBasicInformationResource;
